'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../external/classnames/index.js');

var PropTypes = require('prop-types');

var Button = require('../../primitives/Button/Button.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var AlertBanner = function AlertBanner(props) {
  var btnLabel = props.btnLabel,
      href = props.href,
      message = props.message,
      Tag = props.tag,
      title = props.title;
  var alertClasses = index['default']('lanl-alert-banner');
  return /*#__PURE__*/React__default['default'].createElement(Tag, {
    "data-testid": "alert-banner",
    className: alertClasses,
    role: "alert"
  }, /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "message"
  }, message), /*#__PURE__*/React__default['default'].createElement(Button.Button, {
    href: href,
    outline: true,
    color: "black"
  }, btnLabel));
};

AlertBanner.defaultProps = {
  btnLabel: 'More Information',
  tag: 'div'
};
AlertBanner.propTypes = {
  btnLabel: PropTypes__default['default'].string,
  href: PropTypes__default['default'].string,
  message: PropTypes__default['default'].string,
  tag: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string
};
exports.AlertBanner = AlertBanner;
exports['default'] = AlertBanner;